module.exports = __webpack_public_path__ + "static/media/guest-wrong-answer.7e272480.gif";